// tippi/src/pages/carrier/CarrierDashboard.js
import React, { useState } from 'react';
import { NavLink, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Navbar from '../../components/common/Navbar';
import { useAuth } from '../../contexts/AuthContext';
import { useCarrierOrg } from '../../hooks/useCarrierOrg';
import { carrierApi } from '../../firebase/functionsService';
import CarrierOverview from './CarrierOverview';
import CarrierVehicles from './CarrierVehicles';
import NewVehiclePage from './NewVehiclePage';
import VehicleDetail from './VehicleDetail';
import CarrierDrivers from './CarrierDrivers';
import CarrierSettings from './CarrierSettings';
import CarrierOrders from './CarrierOrders';
import NewCarrierOrderPage from './NewCarrierOrderPage';
import CarrierOrderDetail from './CarrierOrderDetail';
import CarrierCustomers from './CarrierCustomers';
import { ui } from './carrierStyles';

function Tab({ to, end, children }) {
  return (
    <NavLink
      to={to}
      end={end}
      style={({ isActive }) => ({
        padding: '8px 14px', borderRadius: 8, textDecoration: 'none', whiteSpace: 'nowrap', fontSize: 14,
        color: isActive ? '#fff' : 'rgba(255,255,255,0.7)',
        background: isActive ? '#2d2d4e' : 'transparent',
        fontWeight: isActive ? 600 : 400,
      })}
    >
      {children}
    </NavLink>
  );
}

// Vises for en transportør-bruker som ikke (lenger) har et firma, for eksempel etter at registreringen ble avbrutt.
function NoOrg() {
  const { refreshUserDoc } = useAuth();
  const [busy, setBusy] = useState(false);
  const location = useLocation();
  const [error, setError] = useState(location.state?.error || '');

  async function create() {
    setBusy(true);
    setError('');
    try {
      await carrierApi.createCarrierOrg();
      await refreshUserDoc();
    } catch (err) {
      setError(err.message || 'Kunne ikke opprette transportfirma');
    } finally {
      setBusy(false);
    }
  }

  return (
    <main style={ui.main}>
      <h1 style={ui.h1}>Transportfirma</h1>
      <div style={ui.card}>
        <p style={ui.hint}>Kontoen din er ikke knyttet til et transportfirma ennå. Opprett firmaet med organisasjonsnummeret fra kontoen din, eller be en administrator invitere deg.</p>
        {error && <p role="alert" style={ui.error}>{error}</p>}
        <button type="button" className="tippi-btn" style={{ ...ui.btn, marginTop: 14 }} onClick={create} disabled={busy}>
          {busy ? 'Oppretter…' : 'Opprett transportørfirma'}
        </button>
      </div>
    </main>
  );
}

export default function CarrierDashboard() {
  const { loading, orgId, org, isAdmin } = useCarrierOrg();

  if (loading) {
    return <div style={ui.root}><Navbar /><main style={ui.main}><p style={ui.hint}>Laster…</p></main></div>;
  }
  if (!orgId || !org) {
    return <div style={ui.root}><Navbar /><NoOrg /></div>;
  }

  return (
    <div style={ui.root}>
      <Navbar />
      <nav style={ui.tabs} aria-label="Transportør">
        <Tab to="/transportor" end>Oversikt</Tab>
        <Tab to="/transportor/ordre">Ordre</Tab>
        <Tab to="/transportor/biler">Biler</Tab>
        <Tab to="/transportor/sjaforer">Sjåfører</Tab>
        <Tab to="/transportor/kunder">Kunder</Tab>
        {isAdmin && <Tab to="/transportor/innstillinger">Innstillinger</Tab>}
      </nav>
      <main style={ui.main}>
        <Routes>
          <Route index element={<CarrierOverview />} />
          <Route path="biler" element={<CarrierVehicles />} />
          <Route path="biler/ny" element={<NewVehiclePage />} />
          <Route path="biler/:vehicleId" element={<VehicleDetail />} />
          <Route path="sjaforer" element={<CarrierDrivers />} />
          <Route path="kunder" element={<CarrierCustomers />} />
          <Route path="ordre" element={<CarrierOrders />} />
          <Route path="ordre/ny" element={<NewCarrierOrderPage />} />
          <Route path="ordre/:orderId" element={<CarrierOrderDetail />} />
          <Route path="innstillinger" element={<CarrierSettings />} />
          <Route path="*" element={<Navigate to="/transportor" replace />} />
        </Routes>
      </main>
    </div>
  );
}
